module.exports = __webpack_public_path__ + "img/paypal.c887d4d1.png";